import axios from "axios";
import QS from "qs";
import moment from "moment-timezone"
import xlooLib from "../../../librarys/xlooLib";

export default {
    SET_homeSlider: async (context) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        const dataRequest = {
            action: 'getSlider',
        }
        try {
            const resPortalSlider = await axios.post(urlRequest, QS.stringify(dataRequest))
            let result = resPortalSlider.data.result.entry_list

            if (result.length > 0) {
                let arrSliders = [];
                result.sort((a, b) => {
                    const aVal = a.name_value_list.order_index.value
                    const bVal = b.name_value_list.order_index.value
                    if (aVal > bVal) return -1
                    return 1
                });
                // eslint-disable-next-line no-unused-vars
                const dateUpdate = new Date(moment.utc(context.rootGetters["settingsAndCustomize/siteCustomizationData"].dataCacheUpdate, "YYYY-MM-DD hh:mm:ss"))

                for (let i = 0; i < result.length; ++i) {
                    let urlImage = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite
                        + 'img/sliders/slide_'
                        + result[i].id
                        + '_' + context.rootGetters['settingsAndCustomize/hash']
                        + '.' + result[i].name_value_list.file_ext.value
                    arrSliders.push({
                        urlImage: urlImage,
                        bannerSlide: xlooLib.decodeHtmlEntity(result[i].name_value_list.banner.value),
                        linkButton: result[i].name_value_list.link.value,
                        labelButton: xlooLib.decodeHtmlEntity(result[i].name_value_list.button.value),
                        order: i,
                        showArrow: result[i].name_value_list.show_arrow.value,
                    })
                }
                context.commit('settingsAndCustomize/set_siteCustomizationHomePage', {slider: arrSliders}, {root: true})
                return arrSliders
            }
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    // eslint-disable-next-line no-unused-vars
    SET_setEntry: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'

        let dataRequest ={}

        Object.keys(payload).forEach(function(key) {
            dataRequest[key] = payload[key]
        }, payload);


        try {
            const response = await axios.post(urlRequest, QS.stringify(dataRequest))

            return response
        }  catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_entryPoint:  async (context, payload) => {
        if (typeof payload.action === 'undefined' || payload?.action === ''){
            return {error: 'undefined Action field'}
        }
        if (typeof payload.entryAction === 'undefined' || payload?.entryAction === ''){
            return {error: 'undefined Entry Action field'}
        }
        if (typeof payload.entryPoint === 'undefined' || payload?.entryPoint === ''){
            payload.entryPoint = 'appointment_calendar'
        }

        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        let dataRequest = {
            action: payload.action,
        }
        Object.keys(payload).forEach( key => {
            dataRequest[key] = payload[key]
        }, payload);
        try {
            const response = await axios.post(urlRequest, QS.stringify(dataRequest))
            return response
        }  catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_apiPointPortal: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api'
        let dataRequest = payload

        dataRequest.action = 'apiPointPortal'

        try {
            const result = await axios.post(urlRequest, QS.stringify(dataRequest));

            return result?.data?.result
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
}
